export const SET_IS_VRBUTTON_ENABLED = 'SET_IS_VRBUTTON_ENABLED'
export const SET_ARE_SHAREBUTTONS_ENABLED = 'SET_ARE_SHAREBUTTONS_ENABLED'
export const SET_ARE_ACTIONBUTTONS_ENABLED = 'SET_ARE_ACTIONBUTTONS_ENABLED'
